export default __webpack_public_path__ + "static/media/icon-system-usability-test.b09d6e74.svg";